import { render, staticRenderFns } from "./Listitem.vue?vue&type=template&id=5281d462"
import script from "./Listitem.vue?vue&type=script&lang=ts"
export * from "./Listitem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports